import styled from '@emotion/styled';

export const ContentSectionWrapper = styled.div`
  width: 100%;
  margin: auto;
  position: fixed;
  z-index: 5;
  padding: 32px 16px 16px;
  background-color: white;
  border-radius: 10px 10px 0 0;

  .expand-tap {
    position: fixed;
    bottom: 0;
    left: 0;
  }

  &.expanded {
    position: relative;
    margin-top: -352px;

    @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
      margin-top: -335px;
    }

    .h1 {
      display: block;
    }

    .gradient-scale {
      visibility: visible;
    }

    .expand-tap {
      display: none;
    }
  }

  &.position-selected {
    margin-top: 0;

    .expand-tap {
      display: none;
    }

    @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
      margin-top: -335px;
    }
  }

  &::-webkit-scrollbar {
    width: 10px;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d3d3d3;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track {
    background: #efefef;
  }
  @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
    position: relative;
    border-radius: 2px;
    width: 100%;
    max-width: 877px;
    padding: 40px;
    background-color: #fff;
    overflow-x: hidden;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.33);
    margin-top: -335px;
    margin-bottom: 32px;

    .review-bar {
      display: none;
    }

    .expand-tap {
      display: none;
    }
  }

  .collapse-button {
    background: #c4c4c4;
    top: 12px;
    content: '';
    display: block;
    height: 5px;
    left: 50%;
    position: absolute;
    width: 40px;
    border-radius: 5px;
    transform: translateX(-50%);
    padding: 0;

    &:hover {
      background: #c4c4c4;
    }

    @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
      display: none;
    }
  }

  .h1 {
    display: none;
    letter-spacing: 0.01em;
    margin: auto;
    max-width: 700px;
    text-align: left;
    margin-bottom: 16px;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
      display: block;
      margin-bottom: 24px;
      text-align: center;
    }
  }

  .bottom-title {
    font-size: 18px;
    text-align: center;
    padding-top: 24px;
    color: #a9a9a9;
    display: none;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
      display: block;
    }

    span {
      color: #004b54;
    }
  }

  .seperate-line {
    margin: 24px -16px;
    border-bottom-width: 0;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
      margin: 48px -40px;
    }
  }

  .gradient-scale {
    visibility: hidden;
  }
`;
